import { categoryGroupSelectors } from "../Selectors/index";

const initValue = {
  loading: false,
  rows: [],
};

export const categoryGroupReducer = (state = initValue, { type, payload }) => {
  switch (type) {
    case categoryGroupSelectors.GET_CATEGORY_GROUP:
      return {
        ...state,
        loading: true,
      };
    case categoryGroupSelectors.GET_CATEGORY_GROUP_SUCCESS:
      return {
        loading: false,
        rows: payload,
      };

    default:
      return state;
  }
};
